export const UpdateAccountAccessRightIdSelector = 'accessRightId';
export const UpdateAccountAccessRightsArraySelector = 'accountAccessRights';
export const UpdateAccountsAccessRightsArraySelector = 'accountsAccessRights';

export const UpdateAccountInArrayErrorPlaceholder = 'permissions';
